type Handler = (payload?: any) => void
const map = new Map<string, Set<Handler>>()
const lastMap = new Map<string, any>()

export const on = (event: string, handler: Handler) => {
  let set = map.get(event)
  if (!set) { set = new Set(); map.set(event, set) }
  set.add(handler)
}

export const off = (event: string, handler: Handler) => {
  const set = map.get(event)
  if (set) {
    set.delete(handler)
    if (set.size === 0) map.delete(event)
  }
}

export const emit = (event: string, payload?: any) => {
  lastMap.set(event, payload)
  const set = map.get(event)
  if (set) {
    for (const h of Array.from(set)) {
      try { h(payload) } catch { }
    }
  }
}

export const getLast = (event: string) => lastMap.get(event)

export default { on, off, emit, getLast }
